<div class="row w-100" [@.disabled]="expandAll" [id]="instrument.instrument_id">
    @switch (instrument.provenance) {
    @case ('FactSet') {
    @if (canShowFactSetData) {
    <ng-container *ngTemplateOutlet="factsetOverview; context: {$implicit: instrument.factset}"></ng-container>
    }
    }
    @case ('FactSet/OpenFigi') {
    @if (canShowFactSetData) {
    <ng-container *ngTemplateOutlet="factsetOverview; context: {$implicit: instrument.factset}"></ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="figiOverview; context: {$implicit: instrument.openfigi}"></ng-container>
    }
    }
    @case ('OpenFigi') {
    <ng-container *ngTemplateOutlet="figiOverview; context: {$implicit: instrument.openfigi}"></ng-container>
    }
    @default {
    @if (instrument.instrument_top_type != 'DIP' && (instrument.instrument_dateofissuance || instrument.instrument_maturity_date || instrument.instrument_qualities?.length || instrument.instrument_new_money_debt ||
    instrument.instrument_bridge_financing_facility || instrument.post_cancelled) ) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">
            OVERVIEW
        </h2>
        <ng-container *ngTemplateOutlet="overviewTable; context: {$implicit: instrument}"></ng-container>
    </div>
    }
    }
    }

    @if (instrument.dip_data && instrument.dip_data.instrument_dateofissuance?.length + instrument.dip_data.dip_interim_amount?.length + instrument.dip_data.dip_priority_prime_everything?.length + instrument.dip_data.dip_collateral_all_assets?.length
    + instrument.dip_data.dip_avoidance_action_liens?.length > 0 ) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">OVERVIEW</h2>
        <table class="table table-borderless definitions w-100">
            @if (instrument.instrument_type) {
            <tr>
                <td>Instrument Type:</td>
                <td>{{ instrument.instrument_type}}</td>
            </tr>
            }
            @if (instrument.instrument_sub_type) {
            <tr>
                <td>Instrument Sub-Type:</td>
                <td>{{ instrument.instrument_sub_type}}</td>
            </tr>
            }
            @if (instrument.instrument_priority) {
            <tr>
                <td>Security Priority:</td>
                <td>{{ instrument.instrument_priority}}</td>
            </tr>
            }
            @if (instrument.instrument_security) {
            <tr>
                <td>Level of Security:</td>
                <td>{{ instrument.instrument_security}}</td>
            </tr>
            }
            @if (instrument.dip_data.instrument_dateofissuance) {
            <tr>
                <td>Issuance Date:</td>
                <td>{{ instrument.dip_data.instrument_dateofissuance | date }}</td>
            </tr>
            }
            @if (instrument.instrument_maturity_date) {
            <tr>
                <td>Maturity Date:</td>
                <td>{{ instrument.instrument_maturity_date | date }}</td>
            </tr>
            }
            @if (instrument.instrument_amount) {
            <tr>
                <td>Issuance Amount:</td>
                <td>
                    @if ( instrument.instrument_amount?.includes(',')) {
                    {{ instrument.instrument_amount }}
                    } @else {
                    {{ instrument.instrument_amount | currency: instrument.instrument_amount_currency }}
                    }
                </td>
            </tr>
            }
            @if (instrument.dip_data.dip_interim_amount) {
            <tr>
                <td>Interim Amount:</td>
                <td>{{ instrument.dip_data.dip_interim_amount | currency: instrument.dip_data.instrument_amount_currency }}</td>
            </tr>
            }
            @if (instrument.interest_rates) {
            <tr>
                <td>Interest:</td>
                <td> {{ instrument.interest_rates}}</td>
            </tr>
            }
            @if (instrument.dip_data.dip_priority_prime_everything) {
            <tr>
                <td>Priority Prime Everything:</td>
                <td>{{ instrument.dip_data.dip_priority_prime_everything }}</td>
            </tr>
            }
            @if (instrument.dip_data.dip_collateral_all_assets) {
            <tr>
                <td>Collateral: All Assets:</td>
                <td>{{ instrument.dip_data.dip_collateral_all_assets }}</td>
            </tr>
            }
            @if (instrument.dip_data.dip_avoidance_action_liens) {
            <tr>
                <td>Lien on Avoidance Action:</td>
                <td>{{ instrument.dip_data.dip_avoidance_action_liens }}</td>
            </tr>
            }
            @if (instrument.dip_status) {
            <tr>
                <td>DIP Status:</td>
                <td>{{ instrument.dip_status }}</td>
            </tr>
            }
        </table>
    </div>
    }

    @if (instrument.dip_timelines && instrument.dip_timelines.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">TIMELINE</h2>
        <table class="table table-borderless definitions w-100">
            @for (timepoint of instrument.dip_timelines; track timepoint) {

            <tr>
                <td>
                    {{ timepoint.term}}
                    @if (timepoint.description.length > 5) {
                    ({{ timepoint.description | stripTags }})
                    }
                </td>
                <td class="ps-2">{{ timepoint.date_of_timeline | date}}</td>
            </tr>

            }
        </table>
    </div>
    }


    @if (instrument.dip_data?.dip_milestones && instrument.dip_data.dip_milestones.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">
            DIP MILESTONES
        </h2>
        <table cdk-table [dataSource]="instrument.dip_data.dip_milestones" class="table table-borderless definitions w-100 table-striped">
            <ng-container cdkColumnDef="milestone_type">
                <th cdk-header-cell *cdkHeaderCellDef> Type </th>
                <td cdk-cell *cdkCellDef="let milestone" class="pr-2">
                    @if (milestone.milestone_type != 'Other') {
                    <span>{{ milestone.milestone_type }}</span>
                    }
                    @if (milestone.milestone_type == 'Other') {
                    <span>{{ milestone.milestone_type_other }}</span>
                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="date">
                <th cdk-header-cell *cdkHeaderCellDef> Timing </th>
                <td cdk-cell *cdkCellDef="let milestone">
                    @if (milestone.date.length > 2) {
                    <span class="text-nowrap">
                        {{ milestone.date | date }}
                    </span>
                    } @else {

                    @if (milestone.date_textual == '0') {

                    On

                    }
                    @if (milestone.date_textual > 0) {

                    {{ milestone.date_textual }} days after

                    }
                    @if (milestone.date_textual < 0) { {{ milestone.date_textual * -1 }} days before } @if (milestone.milestone_event !='Other' ) { <span>{{ milestone.milestone_event }}</span>
                        }
                        @if (milestone.milestone_event == 'Other') {
                        <span>{{ milestone.milestone_event_other }}</span>
                        }

                        }
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="['milestone_type', 'date']"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: ['milestone_type', 'date']"></tr>
        </table>
    </div>
    }


    <ng-container *ngTemplateOutlet="instrument_obligated_companies_column; context: {$implicit: instrument.obligated_companies, instrument_id: instrument.instrument_id}"></ng-container>
    <ng-container
        *ngTemplateOutlet="instrument_lenders_column; context: {instrument_id: instrument.instrument_id, involved_parties: instrument.instrument_involved_parties_data, columns: instrument.instrument_involved_parties_columns, current_dip: instrument.dip_data}">
    </ng-container>
    <ng-container *ngTemplateOutlet="instrument_debt_security; context: {instrument_id: instrument.instrument_id, $implicit: instrument }"></ng-container>
    <ng-container *ngTemplateOutlet="fees_column; context: {$implicit: instrument.instrument_fees, instrument_id: instrument.instrument_id}"></ng-container>
    <ng-container *ngTemplateOutlet="ratings_column; context: {$implicit: instrument.instrument_ratings, instrument_id: instrument.instrument_id}"></ng-container>


    @if (instrumentIsBondWithFigi()) {
    <div class="col-12">
        <app-bond-pricing-graph [figi]="instrumentIsBondWithFigi()" [showBondData]="true"></app-bond-pricing-graph>
    </div>
    }

    @if (instrument.dip_data?.dip_adequate_protectionss && instrument.dip_data.dip_adequate_protectionss.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">ADEQUATE PROTECTION</h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @for (protection of instrument.dip_data.dip_adequate_protectionss; track protection) {

                <tr>
                    <td>
                        {{ protection.group_name }}
                    </td>
                    <td class="ps-2 pb-2">
                        <ul class="list-unstyled mb-0">
                            @for (adequateProtection of protection.dip_adequate_protections; track adequateProtection) {

                            <li>
                                @if (adequateProtection !== 'Other') {
                                {{ adequateProtection }}
                                }
                                @if (adequateProtection == 'Interest' && protection.dip_adequate_protections_interest !== '') {
                                ({{protection.dip_adequate_protections_interest}})
                                }
                                @if (adequateProtection == 'Other' && protection.other_protection.length) {
                                Other:
                                <ul class="comma-list">
                                    @for (otherProtection of protection.other_protection; track otherProtection) {
                                    <li>
                                        {{ otherProtection.other_adequate_protection}}
                                    </li>
                                    }
                                </ul>

                                }
                            </li>

                            }
                        </ul>
                    </td>
                </tr>

                }
            </tbody>
        </table>
    </div>
    }
    @if ((instrument.dip_data?.dip_investigation_budget && instrument.dip_data.dip_investigation_budget> 0) || instrument.dip_data?.dip_professional_line_item || instrument.dip_data?.dip_carve_out > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        @if (instrument.dip_data.dip_investigation_budget && instrument.dip_data.dip_investigation_budget> 0 || instrument.dip_data.dip_carve_out > 0) {

        <h2 class="column-header">
            UCC CONCERNS
        </h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @if (instrument.dip_data.dip_investigation_budget > 0) {
                <tr>
                    <td>Investigation Budget</td>
                    <td>
                        {{ instrument.dip_data.dip_investigation_budget | currency}}
                        <ng-container *ngTemplateOutlet="dipChangedInfo; context: {$implicit: instrument, field: 'dip_investigation_budget', currency: 'USD'}"></ng-container>
                    </td>
                </tr>
                }
                @if (instrument.dip_data.dip_investigation_deadline > 0) {
                <tr>
                    <td>Investigation Deadline </td>
                    <td>
                        {{ instrument.dip_data.dip_investigation_deadline }} days
                        @if (instrument.dip_data.dip_ucc_sublimit_amount > 0) {

                        (UCC Sublimit {{ instrument.dip_data.dip_ucc_sublimit_amount }} days)

                        }
                        <ng-container *ngTemplateOutlet="dipChangedInfo; context: {$implicit: instrument, field: 'dip_investigation_deadline', currency: 'USD'}"></ng-container>
                    </td>
                </tr>
                }
                @if (instrument.dip_data.dip_carve_out > 0) {
                <tr>
                    <td>Carve-Out</td>
                    <td>
                        {{ instrument.dip_data.dip_carve_out | currency }}
                        <ng-container *ngTemplateOutlet="dipChangedInfo; context: {$implicit: instrument, field: 'dip_carve_out', currency: 'USD'}"></ng-container>
                        @if (instrument.dip_data.dip_professional_breakdown == 'Yes') {

                        (Professional Breakdown: yes)

                        }
                    </td>
                </tr>
                }
            </tbody>
        </table>

        }
        @if (instrument.dip_data?.dip_professional_line_item) {

        <h2 class="column-header">
            OTHERS
        </h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                <tr>
                    <td>Professional Line Item</td>
                    <td>{{ instrument.dip_data.dip_professional_line_item | currency }} ({{ instrument.dip_data.dip_professional_line_item_period}} Weeks)</td>
                </tr>
                @if (instrument.dip_data.dip_waivers.length) {
                <tr>
                    <td>Waivers </td>
                    <td>
                        {{ instrument.dip_data.dip_waivers.join(', ')}}
                    </td>
                </tr>
                }
            </tbody>
        </table>

        }
    </div>
    }
    @if (instrument.dip_data?.dip_roll_ups && instrument.dip_data?.dip_roll_ups.length) {
    <div class="col-lg-12 col-xl-6 my-2">
        <h2 class="column-header">DIP ROLL-UP/REFI</h2>
        @if (instrument.dip_data.dip_roll_ups && instrument.dip_data.dip_roll_ups.length) {
        <table cdk-table [dataSource]="instrument.dip_data.dip_roll_ups" class="table table-borderless definitions w-100 table-striped" multiTemplateDataRows>
            <ng-container cdkColumnDef="type">
                <th cdk-header-cell *cdkHeaderCellDef>Type</th>
                <td cdk-cell *cdkCellDef="let rollup" class="text-nowrap pr-1">
                    {{ rollup.type }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="amount_usd">
                <th cdk-header-cell *cdkHeaderCellDef> Amount </th>
                <td cdk-cell *cdkCellDef="let rollup">
                    {{ rollup.amount_usd | currency}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="creeping">
                <th cdk-header-cell *cdkHeaderCellDef> Creeping </th>
                <td cdk-cell *cdkCellDef="let rollup">
                    {{ rollup.creeping }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="rollup_new_money_ratio">
                <th cdk-header-cell *cdkHeaderCellDef class="text-center px-1"> Roll up / New Money Ratio </th>
                <td cdk-cell *cdkCellDef="let rollup" class="text-center px-1">
                    {{ rollup.rollup_new_money_ratio }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="pre_petition_instrument">
                <th cdk-header-cell *cdkHeaderCellDef> Instrument </th>
                <td cdk-cell *cdkCellDef="let rollup">
                    <ul class="list-unstyled mb-0">
                        @for (pre_petition_instrument of rollup.pre_petition_instrument; track pre_petition_instrument) {

                        <li><a class="a_without_href" (click)="openInstrument($event, instrument.case_id, pre_petition_instrument.id)">{{pre_petition_instrument.name}}</a> </li>

                        }
                    </ul>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="notes">
                <th cdk-header-cell *cdkHeaderCellDef> Notes </th>
                <td cdk-cell *cdkCellDef="let rollup" [innerHTML]="rollup.notes" class="plain" [attr.colspan]="6">

                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="instrument.dip_data.dip_roll_ups_columns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: instrument.dip_data.dip_roll_ups_columns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: ['notes']"></tr>
        </table>
        }
    </div>
    }


    @if (instrument.dip_data?.dip_terms && instrument.dip_data.dip_terms.length) {
    <div class="col-lg-12 col-xl-6 my-2">
        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: instrument.dip_data.dip_terms, heading: 'TERM', classes: 'column-header'}"></ng-container>
        <table class="table table-borderless definitions w-100">
            <thead>
                <tr>
                    <th>Term</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                @for (term of instrument.dip_data.dip_terms; track term) {

                <tr>
                    <td class="pr-2">{{ term.term }}</td>
                    <td class="add-format" [innerHTML]="term.description"></td>
                </tr>

                }
            </tbody>
        </table>
    </div>
    }

    <ng-container *ngTemplateOutlet="instrument_updates_columns; context: {$implicit: instrument.instrument_updates_with_columns, instrument_id: instrument.instrument_id}"></ng-container>

    @if (instrument.holdings?.length) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            HOLDINGS
        </h2>
        <auto-filter-table [data]="instrument.holdings" [columns]="instrumentHoldingsColumns"></auto-filter-table>
    </div>
    }

    @if (instrument.consolidatedHoldings) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            HOLDINGS (as of {{instrument.consolidatedHoldings.reportingDate | date}})
        </h2>
        <table class="table table-borderless w-100">
            <thead>
                <tr>
                    <th></th>
                    <th>Company</th>
                    <th>Report Date</th>
                    <th class="text-end">Amount</th>
                    <th class="text-end">Amount Change</th>
                    <th class="text-end">Percentage</th>
                    <th>Portfolio Name</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                @for (holding of instrument.consolidatedHoldings.holdings; track holding) {
                <tr [class.border-bottom]="!isHoldingExpanded[holding.current.entity_id]">
                    @if (holding.past.length > 0) {
                    <td (click)="isHoldingExpanded[holding.current.entity_id] = ! isHoldingExpanded[holding.current.entity_id]" class="row-toggle">
                        <ng-icon name="bootstrapChevronDown"  size="16px"  [@openClose]="isHoldingExpanded[holding.current.entity_id] ? 'open' : 'closed'" class="d-inline-block"></ng-icon>
                    </td>
                    } @else {
                    <td></td>
                    }
                    <td><followable-link area="organizations" [articleid]="holding.current.entity_id" [label]="holding.current.entityName"></followable-link></td>
                    <td>{{holding.current.report_date | date}}</td>
                    <td class="text-end">{{holding.current.holding_amount | currency}}</td>
                    <td class="text-end">{{holding.current.amount_change | currency}}</td>
                    <td class="text-end">{{holding.current.percentage_outstanding}}%</td>
                    <td>{{holding.current.portfolio_name}}</td>
                    <td>{{holding.current.role}}</td>
                </tr>
                @if (holding.past.length > 0 && isHoldingExpanded[holding.current.entity_id]) {
                @for (previousHolding of holding.past; track previousHolding; let i = $index) {
                <tr [class.border-bottom]="isHoldingExpanded[holding.current.entity_id] && i === holding.past.length - 1">
                    <td></td>
                    <td> </td>
                    <td>{{holding.current.report_date | date}}</td>
                    <td class="text-end">{{previousHolding.holding_amount | currency}}</td>
                    <td class="text-end">{{previousHolding.amount_change | currency}}</td>
                    <td class="text-end">{{previousHolding.percentage_outstanding}}%</td>
                    <td> </td>
                    <td> </td>
                </tr>
                }

                }
                }
            </tbody>
        </table>

    </div>
    }

    <ng-container *ngTemplateOutlet="plan_treatments; context: {$implicit: instrument.planTreatments, situationID: instrument.ngr_company_id, treatmentColumnVisibility: instrument.treatmentColumnVisibility}"></ng-container>
    <ng-container *ngTemplateOutlet="treatment_consideration; context: {$implicit: instrument.treatmentConsiderations, situationID: instrument.ngr_company_id, treatmentColumnVisibility: instrument.treatmentColumnVisibility}"></ng-container>

    <ng-container *ngTemplateOutlet="instrument_waivers_forbearance; context: {$implicit: instrument.instrument_waivers_forbearance_detail, instrument_id: instrument.instrument_id}"></ng-container>

    <court-documents [documents]="instrument.court_documents" colsDefn="col-12"></court-documents>
</div>

<ng-template #instrument_obligated_companies_column let-allObligatedCmpanies let-instrument_id="instrument_id">
    @if (allObligatedCmpanies?.Borrower.length + allObligatedCmpanies?.Guarantor.length + allObligatedCmpanies?.Issuer.length + allObligatedCmpanies?.Keepwell.length + allObligatedCmpanies?.Other.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">OBLIGATED COMPANIES</h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                <ng-container *ngTemplateOutlet="obligated_company_row; context: {$implicit: allObligatedCmpanies?.Borrower, name: 'Borrower'}"></ng-container>
                <ng-container *ngTemplateOutlet="obligated_company_row; context: {$implicit: allObligatedCmpanies?.Issuer, name: 'Issuer'}"></ng-container>
                <ng-container *ngTemplateOutlet="obligated_company_row; context: {$implicit: allObligatedCmpanies?.Guarantor, name: 'Guarantor'}"></ng-container>
                <ng-container *ngTemplateOutlet="obligated_company_row; context: {$implicit: allObligatedCmpanies?.Keepwell, name: 'Keepwell'}"></ng-container>
                <ng-container *ngTemplateOutlet="obligated_company_row; context: {$implicit: allObligatedCmpanies?.Other, name: 'Other'}"></ng-container>
            </tbody>
        </table>
    </div>
    }
</ng-template>

<ng-template #obligated_company_row let-data let-name="name">
    @if (data && data.length) {
    <tr>
        @if (data.length === 1) {
        <td class="pr-2">{{ name }}</td>
        }
        @if (data.length > 1) {
        <td class="pr-2">{{ name }}s</td>
        }
        <td class="pb-2">
            <ul class="list-unstyled mb-0">
                @for (company of data; track company) {

                <li>{{company}}</li>

                }
            </ul>
        </td>
    </tr>
    }

</ng-template>

<ng-template #instrument_lenders_column let-instrument_id="instrument_id" let-involved_parties="involved_parties" let-columns="columns" let-dip="current_dip">
    @if ((involved_parties && involved_parties.length)) {
    <div class="col-xl-6 col-xxl-4 my-2">
        @if (involved_parties.length) {

        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: involved_parties, heading: 'LENDER', classes: 'column-header'}"></ng-container>
        <table cdk-table [dataSource]="involved_parties" class="table table-borderless definitions w-100">
            <ng-container cdkColumnDef="company_name">
                <th cdk-header-cell *cdkHeaderCellDef> Name </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2">
                    <followable-link area="organizations" [articleid]="party.company_id" [label]="party.company_name"></followable-link>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="role">
                <th cdk-header-cell *cdkHeaderCellDef> Role </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2">
                    <ul class="list-unstyled mb-0">
                        @for (role of party.role; track role) {

                        <li>{{ involvedPartyRoleTitle[role] }}</li>

                        }
                    </ul>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="company_non_roster_roles">
                <th cdk-header-cell *cdkHeaderCellDef> Roles </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2">
                </td>
            </ng-container>
            <ng-container cdkColumnDef="begin_date">
                <th cdk-header-cell *cdkHeaderCellDef> From </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2 text-nowrap">
                    {{ party.begin_date | date }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="end_date">
                <th cdk-header-cell *cdkHeaderCellDef> To </th>
                <td cdk-cell *cdkCellDef="let party" class="px-2 text-nowrap">
                    {{ party.end_date | date }}
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="columns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: columns"></tr>
        </table>

        }
        @if (dip && dip.dip_lender_groups.length) {

        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: dip.dip_lender_groups, heading: 'Lender Group', classes: 'column-header'}"></ng-container>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @for (group of dip.dip_lender_groups; track group) {

                <tr>
                    <td>{{ group.group_name }}</td>
                </tr>

                }
            </tbody>
        </table>

        }
        @if (dip && dip.dip_lender_type) {

        <h2 class="column-header">LENDER TYPE</h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                <tr>
                    <td>{{ dip.dip_lender_type }}</td>
                    <td>
                        <ul class="list-unstyled mb-0">
                            @for (subtype of dip.dip_lender_subtype; track subtype) {

                            <li>{{ subtype | titlecase }}</li>

                            }
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>

        }
    </div>
    }
</ng-template>

<ng-template #pluralheading let-values let-heading="heading" let-classes="classes">
    @if (values.length === 1) {
    <h2 class="{{ classes }}">{{ heading }}</h2>
    }
    @if (values.length > 1 && !classes) {
    <h2>{{ heading }}s</h2>
    }
    @if (values.length > 1 && classes) {
    <h2 class="{{ classes }}">{{ heading }}S</h2>
    }
</ng-template>

<ng-template #instrument_debt_security let-instrument>
    @if (instrument.instrument_secureddebt && instrument.instrument_secureddebt.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">
            DEBT SECURITY
            @if (instrument.factset) {
            <p class="factset-logo">&copy; <img src="assets/factset-logo.svg"> {{ year }}</p>
            }
        </h2>
        @if (instrument.factset) {
        <table class="table table-borderless definitions w-100">
            <tbody>
                @for (security of instrument.factset.instrument_secureddebt; track security) {
                @if (security.lien_priority) {
                <tr>
                    <td>Lien Priority:</td>
                    <td>{{ security.lien_priority}}
                    </td>
                </tr>
                }
                }
                @if (instrument.factset.instrument_collateral_type) {
                <tr>
                    <td>Collateral Type:</td>
                    <td>{{ instrument.factset.instrument_collateral_type}}
                    </td>
                </tr>
                }
                @if (instrument.factset.instrument_collateral_assets) {
                <tr>
                    <td>Collateral Assets:</td>
                    <td>{{ instrument.instrument_collateral_assets}}
                    </td>
                </tr>
                }
            </tbody>
        </table>
        } @else {
        <table class="table table-borderless definitions w-100">
            <thead>
                <tr>
                    <th>Lien Priority</th>
                    <th>Collateral Type</th>
                </tr>
            </thead>
            <tbody>
                @for (security of instrument.instrument_secureddebt; track security) {

                <tr>
                    <td>{{ security.lien_priority }}</td>
                    <td>{{ security.collateral_type }}</td>
                </tr>

                }
            </tbody>
        </table>
        }
        @if (instrument.instrument_debt_security_notes.length > 8) {
        <h2 class="column-header">DEBT SECURITY NOTES</h2>
        <div [innerHTML]="instrument.instrument_debt_security_notes"></div>
        }
    </div>
    }
</ng-template>

<ng-template #fees_column let-fees let-instrument_id="instrument_id">
    @if (fees && fees.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: fees, heading: 'FEE', classes: 'column-header'}"></ng-container>
        @if (fees[0].fee_type === 'No Fee' || fees[0].fee_type === 'Sealed') {
        <p>{{ fees[0].fee_type }}</p>
        } @else {

        <table class="table table-borderless definitions w-100 table-striped">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Period</th>
                </tr>
            </thead>
            <tbody>
                @for (feeRow of fees; track feeRow) {

                <tr>
                    @if (feeRow.fee_type != 'Other Fee') {
                    <td>{{ feeRow.fee_type }}</td>
                    }
                    @if (feeRow.fee_type == 'Other Fee') {
                    <td>{{ feeRow.fee_other }}</td>
                    }
                    @if (feeRow.fee_amount_type == 'USD') {
                    <td>{{ feeRow.fee_amount | currency }}</td>
                    }
                    @if (feeRow.fee_amount_type == '%') {
                    <td>
                        {{ feeRow.fee_amount_percentage }}%
                        @if (feeRow.postpetition_instrument && feeRow.postpetition_instrument.length) {

                        of
                        <ul class="comma-list">
                            @for (instrument of feeRow.postpetition_instrument; track instrument) {
                            <li>
                                {{ instrumentIDLookup[instrument]}}
                            </li>
                            }
                        </ul>

                        }
                    </td>
                    }
                    @if (feeRow.fee_amount_type == 'N/A') {
                    <td>N/A</td>
                    }
                    <td>{{ feeRow.time_period }}</td>
                </tr>

                }
            </tbody>
        </table>

        }
    </div>
    }
</ng-template>

<ng-template #ratings_column let-ratings let-instrument_id="instrument_id">
    @if (ratings && ratings.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: ratings, heading: 'RATING', classes: 'column-header'}"></ng-container>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @for (rating of ratings; track rating.agency) {

                <tr class="title-row">
                    <td>{{ rating.agency }}</td>
                    <ng-container *ngTemplateOutlet="ratingsTDs; context: {$implicit: rating}"></ng-container>
                </tr>
                @for (previous of rating.history; track previous.date) {
                    <tr>
                        <td></td>
                        <ng-container *ngTemplateOutlet="ratingsTDs; context: {$implicit: previous}"></ng-container>
                    </tr>
                    }
                }
            </tbody>
        </table>
    </div>
    }
</ng-template>

<ng-template #ratingsTDs let-rating>
    <td>{{ rating.date | date }}</td>
    <td>
        @if (rating.grading === 'upgrade') {
        <ng-icon name="bootstrapCaretUpFill" size="16px" class="grading text-success"></ng-icon>
        } @else {
            @if (rating.grading === 'downgrade') {
                <ng-icon name="bootstrapCaretDownFill" size="16px" class="grading text-danger"></ng-icon>
            } @else {
                <div class="grading"></div>
            }
        }
        {{ rating.ratingText }}
    </td>
</ng-template>

<ng-template #instrument_updates_columns let-updatesWithColumns let-instrument_id="instrument_id">
    @if (updatesWithColumns && updatesWithColumns.update.length) {
    <div class="col-lg-12 col-xl-6 my-2">
        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: updatesWithColumns.update, heading: 'UPDATE', classes: 'column-header'}"></ng-container>
        <table cdk-table [dataSource]="updatesWithColumns.update" class="table table-borderless definitions w-100 fixed-layout" multiTemplateDataRows>
            <ng-container cdkColumnDef="date_of_update">
                <th cdk-header-cell *cdkHeaderCellDef> Date of Update </th>
                <td cdk-cell *cdkCellDef="let update">
                    @if (update.date_of_update.length > 2) {

                    <p class="my-0"><strong>Date of Update</strong></p>
                    <p>{{ update.date_of_update | date }}</p>

                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="reason_for_change">
                <th cdk-header-cell *cdkHeaderCellDef> Reason For Change </th>
                <td cdk-cell *cdkCellDef="let update">
                    @if (update.reason_for_change.length > 2) {

                    <p class="my-0"><strong>Reason For Change</strong></p>
                    <p>{{ update.reason_for_change}}</p>

                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="security">
                <th cdk-header-cell *cdkHeaderCellDef> Security Priority </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Security Priority</strong></p>
                    <p>{{ update.security }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="priority">
                <th cdk-header-cell *cdkHeaderCellDef> Level of Security </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Level of Security</strong></p>
                    <p>{{ update.priority }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="maturity_date">
                <th cdk-header-cell *cdkHeaderCellDef> Maturity date </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Maturity Date</strong></p>
                    {{ update.maturity_date | date }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="principal_amount">
                <th cdk-header-cell *cdkHeaderCellDef> Principal Amount </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Principal Amount</strong></p>
                    <p>{{ ifStringConvertToFloat(update.principal_amount) | currency }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="update_id">
                <th cdk-header-cell *cdkHeaderCellDef> update_id </th>
                <td cdk-cell *cdkCellDef="let update">
                    {{ update.update_id }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="linked_instruments">
                <th cdk-header-cell *cdkHeaderCellDef> linked_instruments </th>
                <td cdk-cell *cdkCellDef="let update">
                    {{ update.linked_instruments }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="secured_unsecured">
                <th cdk-header-cell *cdkHeaderCellDef> Secured or Unsecured </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Secured or Unsecured</strong></p>
                    <p>{{ update.secured_unsecured }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="share">
                <th cdk-header-cell *cdkHeaderCellDef> Share </th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Share</strong></p>
                    <p>{{ update.share }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="interest_rates">
                <th cdk-header-cell *cdkHeaderCellDef> Interest Rates</th>
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Interest Rates</strong></p>
                    <p>{{ update.interest_rates }}</p>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="converted_exit_facility">
                <td cdk-cell *cdkCellDef="let update">
                    <p class="my-0"><strong>Post-Petition Instruments</strong></p>
                    <ul class="comma-list">
                        @for (id of update.converted_exit_facility; track id) {
                        <li>
                            <a (click)="gotoInstrument(id)" class="a_without_href">{{ instrumentIDLookup[id] }}</a>
                        </li>
                        }
                    </ul>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="notes">
                <td cdk-cell *cdkCellDef="let update" class="plain" [attr.colspan]="6">
                    @if (update.notes.length > 12) {

                    <p class="my-0"><strong>Notes</strong></p>
                    <div class="plain" [innerHTML]="update.notes">
                    </div>

                    }
                </td>
            </ng-container>
            <tr cdk-row *cdkRowDef="let myRowData; columns: updatesWithColumns.columns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: ['notes']"></tr>
        </table>
    </div>
    }
</ng-template>


<ng-template #dipChangedInfo let-dip let-field="field" let-currency="currency">
    @if ((dip.dip_status === 'Final' && (dip.dip_proposed[field] !== dip.dip_interim[field] || dip.dip_final[field] !== dip.dip_interim[field]))
    || (dip.dip_status === 'Intermim' && (dip.dip_proposed[field] !== dip.dip_interim[field]))) {

    <ng-template #tipTemplate>
        <ul class="list-unstyled bg-white text-dark">
            <li>
                <strong>Proposed</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_proposed[field], currency: currency}"></ng-container>
            </li>
            <li>
                <strong>Interim</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_interim[field], currency: currency}"></ng-container>
            </li>
            @if (dip.dip_status === 'Final') {
            <li>
                <strong>Final</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_final[field], currency: currency}"></ng-container>
            </li>
            }
        </ul>
    </ng-template>
    <ng-icon name="bootstrapInfoCircle"  size="16px"  [ngbTooltip]="tipTemplate" containerClass="white-tooltip"></ng-icon>
    }
</ng-template>

<ng-template #instrument_waivers_forbearance let-waivers let-instrument_id="instrument_id">
    @if (waivers && waivers.length) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            WAIVER OR FORBEARANCE
        </h2>
        <table cdk-table [dataSource]="waivers" class="table table-borderless definitions w-100 one-line-first-column">
            <ng-container cdkColumnDef="waivers_type">
                <th cdk-header-cell *cdkHeaderCellDef> Type </th>
                <td cdk-cell *cdkCellDef="let waiver" class="plain">
                    {{waiver.waivers_type}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="Date">
                <th cdk-header-cell *cdkHeaderCellDef>Date</th>
                <td cdk-cell *cdkCellDef="let waiver" class="text-nowrap px-2">
                    {{ waiver.Date | date}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="notes">
                <th cdk-header-cell *cdkHeaderCellDef> Notes </th>
                <td cdk-cell *cdkCellDef="let waiver" class="pr-2" [innerHTML]="waiver.notes">

                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="getNonEmptyColumns(waivers)"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: getNonEmptyColumns(waivers)"></tr>
        </table>
    </div>
    }
</ng-template>


<ng-template #plan_treatments let-planTreatments let-situationID="situationID" let-treatmentColumnVisibility="treatmentColumnVisibility">
    @if (planTreatments && planTreatments.length) {
    <div class="col-12 my-2">
        <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: planTreatments, heading: 'PLAN TREATMENT', classes: 'column-header'}"></ng-container>
        <table class="table border">
            <thead class="grey border-dark">
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Filing Type</th>
                    <th>Filing Date</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                @for (planTreatment of planTreatments; track planTreatment) {

                <tr>
                    <td class="plan-name">
                        <div><span>{{planTreatment.plan.plan_name}}</span></div>
                    </td>
                    <td>{{planTreatment.plan.plan_type}}</td>
                    <td>{{planTreatment.plan.type_of_filing}}</td>
                    <td>{{planTreatment.plan.plan_filing_date | date }}</td>
                    <td>{{planTreatment.plan.plan_status}}</td>
                </tr>
                <tr>
                    <td colspan="12">
                        @if (planTreatment.plan_classes_classified) {
                        <plan-treatment-classified [plan_classes_classified]="planTreatment.plan_classes_classified" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup"
                            [treatmentColumnVisibility]="treatmentColumnVisibility">
                        </plan-treatment-classified>
                        }
                        @if (planTreatment.plan_classes_unclassifieds) {
                        <plan-treatment-unclassified [plan_classes_unclassifieds]="planTreatment.plan_classes_unclassifieds" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup"
                            [treatmentColumnVisibility]="treatmentColumnVisibility">
                        </plan-treatment-unclassified>
                        }
                    </td>
                </tr>

                }
            </tbody>
        </table>
    </div>
    }
</ng-template>
<ng-template #treatment_consideration let-treatmentConsiderations let-situationID="situationID" let-treatmentColumnVisibility="treatmentColumnVisibility">
    @if (treatmentConsiderations && (treatmentConsiderations.plan_classes_classified?.length || treatmentConsiderations.plan_classes_unclassifieds?.length)) {
    <div class="col-12 my-2">
        <h2 class="column-header">
            TREATMENT CONSIDERATION
        </h2>
        <table class="table border">
            <thead class="grey border-dark">
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Filing Type</th>
                    <th>Filing Date</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="plan-name">
                        <div><span>{{treatmentConsiderations.plan.plan_name}}</span></div>
                    </td>
                    <td>{{treatmentConsiderations.plan.plan_type}}</td>
                    <td>{{treatmentConsiderations.plan.type_of_filing}}</td>
                    <td>{{treatmentConsiderations.plan.plan_filing_date| date }}</td>
                    <td>{{treatmentConsiderations.plan.plan_status}}</td>
                </tr>
                <tr>
                    <td colspan="12">
                        @if (treatmentConsiderations.plan_classes_classified) {
                        <plan-treatment-classified [plan_classes_classified]="treatmentConsiderations.plan_classes_classified" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup"
                            [treatmentColumnVisibility]="treatmentColumnVisibility"></plan-treatment-classified>
                        }
                        @if (treatmentConsiderations.plan_classes_unclassifieds) {
                        <plan-treatment-unclassified [plan_classes_unclassifieds]="treatmentConsiderations.plan_classes_unclassifieds" [situationID]="situationID" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup"
                            [treatmentColumnVisibility]="treatmentColumnVisibility">
                        </plan-treatment-unclassified>
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    }
</ng-template>

<ng-template #addCurrency let-value let-currency="currency">
    @if (currency.length) {

    {{ value | currency: currency}}

    }
    @if (!currency.length) {

    {{ value }}

    }
</ng-template>

<ng-template #factsetOverview let-instrument>
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">
            OVERVIEW
            <p class="factset-logo">&copy; <img src="assets/factset-logo.svg"> {{ year }}</p>
        </h2>
        <ng-container *ngTemplateOutlet="overviewTable; context: {$implicit: instrument}"></ng-container>
    </div>
</ng-template>

<ng-template #figiOverview let-instrument>
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">
            OVERVIEW
        </h2>
        <ng-container *ngTemplateOutlet="overviewTable; context: {$implicit: instrument}"></ng-container>
    </div>
</ng-template>

<ng-template #overviewTable let-instrument>
    <table class="table table-borderless definitions w-100">
        <tbody>
            @if (instrument.instrument_fiscal_report_date) {
            <tr>
                <td>Fiscal Report Date:</td>
                <td>{{ instrument.instrument_fiscal_report_date | date}}
                </td>
            </tr>
            }
            @if (instrument.instrument_type) {
            <tr>
                <td>Instrument Type:</td>
                <td>{{ instrument.instrument_type}}
                </td>
            </tr>
            }
            @if (instrument.instrument_sub_type) {
            <tr>
                <td>Instrument Sub-Type:</td>
                <td>{{ instrument.instrument_sub_type}}</td>
            </tr>
            }
            @if (instrument.instrument_detail_type) {
            <tr>
                <td>Instrument Detail Type:</td>
                <td>{{ instrument.instrument_detail_type}}</td>
            </tr>
            }
            @if (instrument.instrument_priority) {
            <tr>
                <td>Security Priority:</td>
                <td>{{ instrument.instrument_priority}}</td>
            </tr>
            }
            @if (instrument.instrument_security) {
            <tr>
                <td>Level of Security:</td>
                <td>
                    {{ instrument.instrument_security}}
                </td>
            </tr>
            }
            @if (instrument.instrument_lending_method?.length > 1) {
            <tr>
                <td>Lending Method:</td>
                <td>{{ instrument.instrument_lending_method}}</td>
            </tr>
            }
            @if (instrument.instrument_dateofissuance) {
            <tr>
                <td>Issuance Date:</td>
                <td>{{ instrument.instrument_dateofissuance | date }}</td>
            </tr>
            }
            @if (instrument.instrument_maturity_date?.length > 1) {
            <tr>
                <td>Maturity Date:</td>
                <td>
                    @if (isDateString(instrument.instrument_maturity_date)) {
                    {{ instrument.instrument_maturity_date | date }}
                    } @else {
                    {{ instrument.instrument_maturity_date }}
                    }
                </td>
            </tr>
            }
            @if (instrument.instrument_amount) {
            <tr>
                <td>Issuance Amount:</td>
                <td>
                    @if (instrument.instrument_amount) {
                    @if ( isStringWithCommas(instrument.instrument_amount)) {
                    {{ instrument.instrument_amount }}
                    } @else {
                    {{ instrument.instrument_amount | currency: instrument.instrument_amount_currency }}
                    }
                    }
                </td>
            </tr>
            }
            @if (instrument.instrument_outstanding_amount) {
            <tr>
                <td>Outstanding Amount:</td>
                <td>
                    @if ( isStringWithCommas(instrument.instrument_outstanding_amount)) {
                    {{ instrument.instrument_outstanding_amount }}
                    } @else {
                    {{ instrument.instrument_outstanding_amount | currency: instrument.instrument_outstanding_amount_currency }}
                    }
                </td>
            </tr>
            }
            @if (instrument.instrument_interest_fees) {
            <tr>
                <td>Interest and Fees:</td>
                <td> {{ instrument.instrument_interest_fees}}</td>
            </tr>
            }
            @if (instrument.interest_rates) {
            <tr>
                <td>Interest:</td>
                <td> {{ instrument.interest_rates}}</td>
            </tr>
            }
            @if (instrument.instrument_interest_type) {
            <tr>
                <td>Fixed/Variable Interest:</td>
                <td>{{ instrument.instrument_interest_type }}</td>
            </tr>
            }
            @if (instrument.instrument_qualities?.join('').trim().length) {
            <tr>
                @if (instrument.instrument_qualities.length === 1) {
                <td>Instrument Quality:</td>
                }
                @if (instrument.instrument_qualities.length > 1) {
                <td>instrument Qualities:</td>
                }
                <td>{{ instrument.instrument_qualities.join(', ') }}</td>
            </tr>
            }
            @if (instrument.instrument_new_money_debt) {
            <tr>
                <td>New Money Debt:</td>
                <td>{{ instrument.instrument_new_money_debt }}</td>
            </tr>
            }
            @if (instrument.instrument_bridge_financing_facility) {
            <tr>
                <td>Bridiging Facility:</td>
                <td>{{ instrument.instrument_bridge_financing_facility }}</td>
            </tr>
            }
            @if (instrument.post_cancelled) {
            <tr>
                <td>Cancelled?:</td>
                <td>{{ instrument.post_cancelled }}</td>
            </tr>
            }
            @if (instrument.instrument_revolver_availability > 0) {
            <tr>
                <td>Revolver Availability:</td>
                <td>{{ instrument.instrument_revolver_availability }}</td>
            </tr>
            }
            @if (instrument.instrument_debt_default_flag && instrument.instrument_debt_default_flag === 'Yes') {
            <tr>
                <td>Debt Default Flag:</td>
                <td>Yes</td>
            </tr>
            }
        </tbody>
    </table>
</ng-template>